import APIS from "../../constant/EndPoint";
import ComboboxInput from "../Reusable/ComboboxInput";
import ProductTypeComboboxInput from "../Reusable/ProductTypeComboBox";

//@ts-ignore
import { tw } from "@careinfo/tailwind";
import TextField from "../Reusable/TextInput";
import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";

const Form = ({
  errors,
  register,
  setValue,
  getValues,
  clearErrors,
  fields,
  watch,
  isSuperUser,
  isActive = true,
  remove,
  append,
}: any) => {
  return (
    <>
      <div className={tw`w-full grid grid-cols-2 gap-x-4 px-4 -m-2`}>
        <>
          <ComboboxInput
            url={APIS.BRANCH}
            queryKey={"branch"}
            register={register("from_branch", {
              required: "Pickup branch is required",
            })}
            errors={errors?.from_branch}
            name={"from_branch"}
            label={"From"}
            props={{ is_active: true }}
            setValue={setValue}
            getValues={getValues}
            disabled={!isActive || !isSuperUser}
            placeholder={"Search  Branch"}
            clearErrors={clearErrors}
          />
          <ComboboxInput
            url={APIS.SHIP_VIA}
            props={{ is_active: true }}
            queryKey={"ship_via"}
            register={register(`ship_via` as const, {
              required: "Ship via is required",
            })}
            errors={errors?.ship_via}
            name={"ship_via"}
            label={"Ship Via"}
            setValue={setValue}
            disabled={!isActive}
            getValues={getValues}
            placeholder={"Search ship via"}
            clearErrors={clearErrors}
          />
        </>
      </div>
      <hr className={tw`mt-6 `} />
      <div>
        {fields.map((field: any, index: any) => {
          return (
            <div key={index} className={tw`-m-2`}>
              <div
                className={tw`relative w-full mt-2 flex justify-between px-4 gap-x-2 uppercase font-extrabold items-center`}
              >
                <div
                  className={tw`text-[#5E5757] font-bold text-[10px] mt-2 -mb-1`}
                >
                  Items {index + 1}
                </div>
                {/* <button
                  type="button"
                  className={tw`rounded p-1 m-1 border border-gray-400 text-xs`}
                  disabled={index === 0 ? true : false}
                  onClick={() => remove(index)}
                >
                  Remove ({index + 1})
                </button> */}
              </div>
              <div
                className={tw`w-full grid grid-cols-7 gap-x-4 px-4 -mt-2 mb-4`}
              >
                <TextField
                  label={"Product Description"}
                  register={register(`items.${index}.description`)}
                  errors={errors?.items?.[index]?.description}
                  disabled={!isActive}
                />
                <TextField
                  label={"Destination"}
                  register={register(`items.${index}.destination`)}
                  errors={errors?.items?.[index]?.destination}
                  disabled={!isActive}
                />
                <ProductTypeComboboxInput
                  url={APIS.PRODUCT_TYPE}
                  queryKey={"product-type"}
                  register={register(`items.${index}.product_type` as const, {
                    required: "Product Type is required",
                  })}
                  errors={errors?.items?.[index]?.product_type}
                  name={`items.${index}.product_type`}
                  label={"Product Type"}
                  setValue={setValue}
                  props={{ is_active: true }}
                  placeholder={"Search Product Type"}
                  getValues={getValues}
                  disabled={!isActive}
                  clearErrors={clearErrors}
                  value={getValues()["items"][index]["product_type"]}
                />
                <TextField
                  label={"Pcs."}
                  register={register(`items.${index}.piece` as const, {
                    required: "Piece is required",
                    valueAsNumber: true,
                    min: {
                      value: 1,
                      message: "Piece must be at least 1",
                    },
                    validate: (value) =>
                      !isNaN(value) || "Piece must be a number",
                  })}
                  disabled={!isActive}
                  errors={errors?.items?.[index]?.piece}
                />
                <TextField
                  label={"Weight(Kg)"}
                  register={register(`items.${index}.weight` as const, {
                    required: "Weight is required",
                    valueAsNumber: true,
                    validate: (value) =>
                      !isNaN(value) || "Weight must be a number",
                  })}
                  disabled={!isActive}
                  errors={errors?.items?.[index]?.weight}
                />
                <TextField
                  label={"Amount"}
                  register={register(`items.${index}.amount` as const, {
                    required: "Amount is required",
                    valueAsNumber: true,
                    validate: (value) =>
                      !isNaN(value) || "Amount must be a number",
                  })}
                  disabled={!isActive}
                  errors={errors?.items?.[index]?.amount}
                />
                <div
                  className={tw`flex items-center justify-start gap-x-2 mt-[30px]`}
                >
                  <button
                    type="button"
                    onClick={() =>
                      append({
                        description: null,
                        destination: null,
                        product_type: null,
                        piece: 1,
                        weight: 0,
                        amount: 0,
                      })
                    }
                    className={tw`p-2 bg-green-100 border hover:bg-green-200 border-green-400 rounded-lg focus:outline-none`}
                  >
                    <PlusIcon className={tw`w-5 h-5 text-green-600`} />
                  </button>

                  {fields.length > 1 && (
                    <button
                      type="button"
                      onClick={() => remove(index)}
                      className={tw`p-2 bg-red-100 hover:bg-red-200 rounded-lg`}
                    >
                      <MinusIcon className={tw`w-5 h-5 text-red-600`} />
                    </button>
                  )}
                </div>
              </div>
            </div>
          );
        })}
        {/* <div className={tw`w-full flex justify-end px-4`}>
          <button
            type="button"
            disabled={!isActive}
            className={tw`rounded p-1 m-1 border border-gray-400 text-xs`}
            onClick={() =>
              append({
                description: null,
                destination: null,
                product_type: null,
                piece: 1,
                weight: 0,
                amount: 0,
              })
            }
          >
            Add Items
          </button>
        </div> */}
        <hr />
        <div className={tw`px-4 -mt-2 -m-2`}>
          <TextField
            register={register("note")}
            label={"Remarks"}
            errors={errors?.note}
            disabled={!isActive}
          />
        </div>
      </div>
    </>
  );
};

export default Form;
